@let s = state$ | async;
@if (enabled() && s?.state === 'loading') {
    <div
        class="summary-loading"
        data-testid="summary-loading"
        role="status"
        aria-busy="true"
        aria-label="Generating page summary"
    >
        <div class="summary-header">
            <hive-icon-component [icon]="faSparkles" size="small" />
            <span class="summary-title">Page summary</span>
        </div>
        @for (_ of skeletonLines; track $index; let i = $index) {
            <span class="summary-skeleton" data-testid="summary-skeleton" [style.animation-delay.ms]="i * 80"></span>
        }
    </div>
} @else if (enabled() && s?.state === 'ready') {
    <div class="summary" data-testid="page-summary">
        <div class="summary-header">
            <hive-icon-component [icon]="faSparkles" size="small" />
            <span class="summary-title">Page summary</span>
            <hive-button
                class="refresh-button"
                emphasis="tertiary"
                size="smallest"
                [icon]="faRefresh"
                hiveTooltip
                hiveTooltipDescription="Regenerate this summary"
                (click)="onRefresh()"
            ></hive-button>
        </div>
        <markdown class="summary-body" ngPreserveWhitespaces [data]="s.summary" />
        <p class="summary-disclaimer" data-testid="summary-disclaimer">{{ disclaimer }}</p>
    </div>
} @else {
    <p class="empty-placeholder" data-testid="copilot-empty-placeholder">{{ placeholder }}</p>
}
